export default __webpack_public_path__ + "static/media/logo-ae-adidas.59d4669d.svg";